import { useEffect, useMemo, useRef, useState } from "react";
import { ChevronDown, Search } from "lucide-react";
import CustomerAvatar from "@/components/customers/CustomerAvatar";

const typeLabel = (t) => (t === "service" ? "Servis" : "Klient fundor");

export default function CustomerPicker({ customers, value, onChange }) {
    const [open, setOpen] = useState(false);
    const [q, setQ] = useState("");
    const ref = useRef(null);
    const selected = customers.find((c) => c.id === value);

    useEffect(() => {
        const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    const list = useMemo(() => {
        const s = q.trim().toLowerCase();
        if (!s) return customers;
        return customers.filter((c) => `${c.name} ${c.phone} ${c.nipt || ""}`.toLowerCase().includes(s));
    }, [customers, q]);

    return (
        <div ref={ref} className="relative" data-testid="sales-customer-picker">
            <button type="button" onClick={() => setOpen((o) => !o)} className="input-field flex items-center gap-3 text-left" data-testid="sales-customer-select">
                {selected ? (
                    <>
                        <CustomerAvatar customer={selected} size={32} />
                        <span className="flex-1 min-w-0 truncate">
                            <b>{selected.name}</b> <span className="text-xs text-slate-500">({typeLabel(selected.type)}) — {selected.phone}</span>
                        </span>
                    </>
                ) : (
                    <span className="flex-1 text-slate-500">— Zgjidh klient —</span>
                )}
                <ChevronDown className="w-4 h-4 text-slate-500 shrink-0" />
            </button>
            {open && (
                <div className="absolute z-30 mt-1 w-full bg-slate-50 border border-slate-200 rounded-lg shadow-xl overflow-hidden" data-testid="sales-customer-dropdown">
                    <div className="relative border-b border-slate-200">
                        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
                        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Kërko klient…" className="w-full pl-9 pr-3 py-2 text-sm outline-none" data-testid="sales-customer-search" />
                    </div>
                    <div className="max-h-72 overflow-auto">
                        {list.length === 0 && <div className="px-3 py-4 text-xs font-mono text-slate-500">Asnjë rezultat</div>}
                        {list.map((c) => (
                            <button
                                type="button"
                                key={c.id}
                                onClick={() => { onChange(c.id); setOpen(false); setQ(""); }}
                                className={`w-full flex items-center gap-3 px-3 py-2 text-left hover:bg-slate-50 ${c.id === value ? "bg-slate-100" : ""}`}
                                data-testid={`sales-customer-option-${c.id}`}
                            >
                                <CustomerAvatar customer={c} size={36} />
                                <span className="min-w-0">
                                    <span className="block text-sm font-semibold truncate">{c.name}</span>
                                    <span className="block text-[11px] font-mono text-slate-500">{typeLabel(c.type)} · {c.phone}</span>
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
